import { injectIntl } from "react-intl";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createSelector } from 'reselect';
import { ediExecutionsLanding, resetPage, set } from '../../../store/actions/pages';
import { getByName, reset } from '../../../store/actions/search';
import { dateEquators, integerEquators, StringEquators } from '../../../store/constants/pages';
import {  createNumberDataField, createStatusFieldAndPopper, createStringDataField, createTimestampField } from '../../../util/format';
import EDIExecutionPageComponent from './EDIExecutionPage';

const selectFields = createSelector(
    () => [
        createNumberDataField('id', 'Execution Id', { equators: integerEquators, sortable: true, }),
        createTimestampField('submittedAt', 'Submitted Time', { sortable: true, equators: dateEquators }),
        createStringDataField('submittedBy', 'Submitted By', { sortable: true, equators: StringEquators }),
        createStatusFieldAndPopper('status', 'State', { sortable: true, equators: StringEquators }),
        createTimestampField('startedAt', 'Started Time', { sortable: true, equators: dateEquators }),
        createTimestampField('completedAt', 'Completed Time', { sortable: true, equators: dateEquators }),
    ]
);

const selectExecutionsData = createSelector(
    (state) => state.pages['edi-executions-landing'].list,
    (data) => data
);

export const EDIExecutionPage = connect(

    () => {
        return (state: any, props) => ({
            fields: selectFields(state as never),
            executionsData: selectExecutionsData(state)
        });
    },
    (dispatch) => ({
        actions: bindActionCreators({
            executionsLanding: ediExecutionsLanding,
            searchGetByName: getByName,
            searchReset: reset,
            setFilter: (value) => set('edi-executions-landing', 'filter', value),
            resetPagedTable: resetPage,
            resetCriteriaWaiting: (pageName) => set(pageName, 'waitForCriteriaFilter', false),
        }, dispatch)
    })
)(injectIntl(EDIExecutionPageComponent));